import React from "react";
import { ConfirmDialog } from "sprint-common-web";

interface ApproveCloudFileDetailsNotificationsDialogProps {
    confirm(): void;
    onClose(): void;
    isOpen: boolean;
}

export const ApproveCloudFileDetailsNotificationsDialog = ({
    confirm,
    onClose,
    isOpen
}: ApproveCloudFileDetailsNotificationsDialogProps): JSX.Element => {
    return (
        <ConfirmDialog
            title="Approve buzz notifications"
            text="Are you sure you want to approve buzz notifications? Once enabled, they cannot be turned off."
            hidden={!isOpen}
            confirm={{ onClick: confirm }}
            cancel={{ onClick: onClose }}
        />
    );
};
